import React, { useRef } from "react";
import "../Styles/TestimonialSection.css";
import SectionHeader from "../components/SectionHeader";
import TestimonialCard from "../components/TestimonialCard";
import SliderBTN from "../components/SliderBTN";

import testimonials from "../contents/testimonials";

const TestimonialsSection = () => {
  const containerRef = useRef(null);

  const handleNext = () => {
    containerRef.current.scrollBy({ left: 380, behavior: "smooth" });
  };

  const handlePrev = () => {
    containerRef.current.scrollBy({ left: -380, behavior: "smooth" });
  };

  return (
    <section className="testimonials-section">
      <SectionHeader
        title="Our Happy Clients"
        subtitle="We use only the best quality materials on the market in order to provide the best products to our patients."
      />
      <div className="cards-scroll-wrapper">
        <div className="cards-container" ref={containerRef}>
          {testimonials.map((testimonial, idx) => (
            <TestimonialCard key={idx} {...testimonial} />
          ))}
        </div>
      </div>
      <SliderBTN onPrev={handlePrev} onNext={handleNext} />
    </section>
  );
};

export default TestimonialsSection;
